<template>
	<div id="footer">
		<div class="container">
			<p>
				北京美信志成咨询有限公司 版权所有
				<a
					href="https://beian.miit.gov.cn/"
					target="_blank"
					style="color:#fff;"
				>京ICP备18014589号-1</a>
			</p>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			};
		},
		methods: {

		}
	};
</script>
